import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'
import { Carousel } from '@mantine/carousel'
import { rem } from '@mantine/core'

export const StyledHomeBannerCarousel = styled(Carousel)`
  .mantine-Carousel-indicators {
    justify-content: flex-end;
    padding-block: ${rem(2)};
    padding-inline: ${rem(12)};
    bottom: ${rem(12)};
  }
`

export const StyledHomeBannerSide = styled.div`
  ${MediaQueries.mbDown} {
    padding-left: ${rem(16)};
    padding-right: ${rem(16)};
  }
`

export const StyledHomeBannerSideWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};

  .homeSideBannerMain,
  .homeSideBannerSide {
    width: 100%;
    border-radius: ${rem(8)};
    overflow: hidden;
  }

  ${MediaQueries.mbUp} {
    & {
      gap: ${rem(16)};
    }
    .homeSideBannerMain {
      flex: 1;
      min-width: 0;
      border-radius: ${rem(12)};
    }
    .homeSideBannerSide {
      width: var(--homeBannerSide-width, 327px);
      border-radius: ${rem(12)};
    }
  }
  ${MediaQueries.lgPcUp} {
    & {
      gap: ${rem(24)};
    }
  }
`

export const StyledHomeBanner = styled.div`
  .homepageBanner {
    margin-bottom: 0;
  }
  .homepageBannerMenu {
    display: none;
  }
`
export const StyledHomeBannerImage = styled.div<{ url?: string }>`
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`
